import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useController } from '@rest-hooks/react';

import EventResource from 'resources/organization/EventResource';
import AIEventCreator from 'components/AIChat/AIEventCreator';
import { useError } from 'utils/useErrorController';

/**
 * AI Event Chat - Orchestrated event + ticket creation via AI chat
 *
 * This component uses the AIEventCreator component which handles:
 * 1. Event creation phase
 * 2. Ticket prompt phase
 * 3. Ticket creation phase (loops for multiple tickets)
 * 4. Redirect to event edit page on completion
 */
const AIEventChat = () => {
  const params = useParams();
  const organizationId = params.organizationId;
  const { fetch } = useController();
  const history = useHistory();
  const { handleError } = useError();

  const handleComplete = async (eventId) => {
    try {
      // Refresh the events lists
      await fetch(EventResource.list(), { organization_id: organizationId, upcoming: true });
      await fetch(EventResource.list(), { organization_id: organizationId });
      await fetch(EventResource.detail(), { organization_id: organizationId, id: eventId });

      // Navigate to event edit page
      history.push(`/organizations/${organizationId}/events/${eventId}/edit`);
    } catch (error) {
      handleError(error);
    }
  };

  return <AIEventCreator onComplete={handleComplete} />;
};

export default AIEventChat;
